/* ============================================================
   SmokeZero · Zéro, la mascotte qui répond (26/10/2026)

   Décision du propriétaire : une mascotte à la place de la FAQ, sur
   l'accueil, les fiches et le panier. Le concept (« aspirateur à
   questions ») :

   - les questions flottent comme des volutes ; touchée, une question vole
     vers la grille de Zéro, qui l'aspire (pose « aspire ») puis rend la
     réponse en clair (pose « répond »), avec un lien ou un produit ;
   - « Quel filtre pour moi ? » ouvre un guide (où, quoi chez toi, budget)
     qui finit sur un produit à ajouter au panier (pose « content ») ;
   - champ libre : la question tapée est aspirée de même ; mots-clés de la
     base, sinon l'équipe ;
   - fiches et panier : quand le visiteur hésite, Zéro passe la tête au
     bord de l'écran ; touché, il ouvre un panneau des questions du
     contexte ; fermé, il ne revient plus de la session.

   Questions et réponses : snippet sz-zero-base (traduit comme le reste du
   thème) ; produits du guide : bloc JSON .zr-data. « Réduire les
   animations » : rien ne flotte ni ne vole, les poses changent sans effet.

   Textes : appels T('clé', 'texte français'), relevés par
   scripts/build-theme.mjs et traduits comme ceux de app.js (window.SZ_T). */
(function () {
  'use strict';
  if (window.__zero) return;
  window.__zero = true;

  var T = function (k, fr, vars) {
    var s = (window.SZ_T && window.SZ_T[k]) || fr;
    if (vars) Object.keys(vars).forEach(function (a) { s = s.split('{' + a + '}').join(vars[a]); });
    return s;
  };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SHOP = window.SZ_SHOP || null;
  var shopRoot = SHOP ? (SHOP.root.slice(-1) === '/' ? SHOP.root : SHOP.root + '/') : null;
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* guide : lieu (puis, chez toi, ce qu'on filtre) → produit par budget : moins de 30 €, 30 à 60 €, plus de 60 €.
     Produit absent ou épuisé : le budget voisin le moins cher, puis le plus cher. */
  var GUIDE = {
    maison: {
      souffle: ['smokebuddy-original', 'yocan-green', 'yocan-green-kit'],
      piece: ['purificateur-compact', 'purificateur-compact', 'purificateur-h13'],
      deux: ['duo-original-compact', 'duo-original-compact', 'duo-original-compact']
    },
    balcon: ['smokebuddy-jr', 'kit-balcon', 'kit-balcon'],
    voiture: ['smokebuddy-jr', 'kit-voiture', 'kit-voiture'],
    coloc: ['smokebuddy-original', 'pack-duo', 'kit-coloc'],
    deplacement: ['smokebuddy-jr', 'yocan-green', 'yocan-green-kit']
  };
  var BUDGET_MAX = [3000, 6000, Infinity];
  var RAISON = {
    maison_souffle: T('zero_raison_souffle', 'Il filtre ce que tu expires, chez toi, sans rien brancher.'),
    maison_piece: T('zero_raison_piece', 'Il filtre l\'air de toute la pièce, en continu.'),
    maison_deux: T('zero_raison_deux', 'Ton souffle et l\'air de la pièce, pour moins cher que séparément.'),
    balcon: T('zero_raison_balcon', 'L\'odeur ne monte pas chez les voisins.'),
    voiture: T('zero_raison_voiture', 'L\'odeur ne s\'installe pas dans l\'habitacle.'),
    coloc: T('zero_raison_coloc', 'L\'air commun reste sans odeur.'),
    deplacement: T('zero_raison_deplacement', 'Il tient dans la poche et ne laisse rien derrière toi.')
  };
  var ETAPES = {
    lieu: { q: T('zero_guide_lieu', 'Où veux-tu garder l\'air sans odeur ?'), o: [
      ['maison', T('zero_lieu_maison', 'Chez moi')], ['balcon', T('zero_lieu_balcon', 'Balcon ou terrasse')],
      ['voiture', T('zero_lieu_voiture', 'En voiture')], ['coloc', T('zero_lieu_coloc', 'En coloc')],
      ['deplacement', T('zero_lieu_deplacement', 'En déplacement')]] },
    besoin: { q: T('zero_guide_besoin', 'Chez toi, tu veux filtrer quoi ?'), o: [
      ['souffle', T('zero_besoin_souffle', 'Ce que j\'expire')], ['piece', T('zero_besoin_piece', 'L\'air de la pièce')],
      ['deux', T('zero_besoin_deux', 'Les deux')]] },
    budget: { q: T('zero_guide_budget', 'Ton budget ?'), o: [
      ['0', T('zero_budget_0', 'Moins de 30 €')], ['1', T('zero_budget_1', '30 à 60 €')], ['2', T('zero_budget_2', 'Plus de 60 €')]] }
  };

  var norm = function (s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ß]+/g, ' '); };

  function Zero(root, ctx) {
    var base = root.querySelector('.zr-base');
    var scene = root.querySelector('.zr-scene');
    var nuage = root.querySelector('.zr-nuage');
    var robot = root.querySelector('.zr-robot');
    var rep = root.querySelector('.zr-reponse');
    var form = root.querySelector('.zr-form');
    var champ = root.querySelector('.zr-champ');
    if (!base || !scene || !nuage || !rep) return;
    var D = {};
    try { D = JSON.parse((root.querySelector('.zr-data') || {}).textContent || '{}'); } catch (e) { D = {}; }
    var P = D.produits || {};

    var QR = $$('article[data-q]', base).map(function (a) {
      var h = a.querySelector('h3'), m = a.querySelector('.zr-mots'), r = a.querySelector('div');
      return { id: a.getAttribute('data-q'), ctx: (a.getAttribute('data-ctx') || '').split(' '), q: h ? h.textContent : '',
        mots: norm(m ? m.textContent : ''), a: r };
    });
    var parId = {};
    QR.forEach(function (x) { parId[x.id] = x; });
    var liste = QR.filter(function (x) { return x.ctx.indexOf(ctx) >= 0 && (x.id !== 'guide' || Object.keys(P).length); });
    var occupe = false;

    function pose(n) {
      $$('.zr-pose', robot).forEach(function (im) { im.classList.toggle('on', im.classList.contains('zr-p-' + n)); });
      if (robot) robot.setAttribute('data-pose', n);
    }

    /* les volutes : chacune dérive à son rythme (amplitude, durée et départ propres) */
    function volutes() {
      nuage.innerHTML = '';
      liste.forEach(function (x, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'zr-wisp' + (x.id === 'guide' ? ' is-guide' : '');
        b.textContent = x.q;
        if (!reduce) {
          b.style.setProperty('--dx', ((k % 2 ? 1 : -1) * (3 + (k * 7) % 6)) + 'px');
          b.style.setProperty('--dy', (-(4 + (k * 5) % 7)) + 'px');
          b.style.setProperty('--dur', (5.5 + (k * 1.3) % 3) + 's');
          b.style.setProperty('--del', (-(k * 0.9) % 4) + 's');
        }
        b.addEventListener('click', function () { demander(x, b.getBoundingClientRect(), b); });
        nuage.appendChild(b);
      });
    }

    /* la grille du dessus de Zéro : là où les questions sont aspirées */
    function grille() {
      var r = (robot || scene).getBoundingClientRect();
      return { x: r.left + r.width * 0.5, y: r.top + r.height * 0.1 };
    }
    function aspirer(rect, texte, fini) {
      pose('aspire');
      if (reduce || !rect) { setTimeout(fini, reduce ? 0 : 420); return; }
      var v = document.createElement('span');
      v.className = 'zr-wisp zr-vol';
      v.setAttribute('aria-hidden', 'true');
      v.textContent = texte;
      v.style.left = rect.left + 'px'; v.style.top = rect.top + 'px';
      v.style.width = rect.width + 'px'; v.style.height = rect.height + 'px';
      document.body.appendChild(v);
      var g = grille(), dx = g.x - (rect.left + rect.width / 2), dy = g.y - (rect.top + rect.height / 2);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          v.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
          v.style.opacity = '0';
          v.style.filter = 'blur(5px)';
        });
      });
      setTimeout(function () { v.remove(); }, 700);
      setTimeout(fini, 640);
    }

    function demander(x, rect, el) {
      if (occupe) return;
      occupe = true;
      scene.classList.remove('a-repondu');
      rep.hidden = true;
      if (el) el.classList.add('parti');
      aspirer(rect, x.q, function () {
        occupe = false;
        if (x.id === 'guide') guide({}); else repondre(x);
      });
    }

    function carte(html, actions) {
      rep.innerHTML = html + '<div class="zr-actions">' + (actions || '') +
        '<button class="zr-autre" type="button">' + esc(T('zero_autre', 'Autre question')) + '</button></div>';
      rep.hidden = false;
      scene.classList.add('a-repondu');
      rep.classList.remove('on'); void rep.offsetWidth; rep.classList.add('on');
      rep.querySelector('.zr-autre').addEventListener('click', retour);
      /* Zéro et sa réponse dans l'écran : sur l'accueil la page défile jusqu'à Zéro, sous l'en-tête ; dans le panneau, le panneau défile */
      var r = rep.getBoundingClientRect();
      if (root.classList.contains('zr-panneau')) { if (r.bottom > innerHeight) rep.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }
      else {
        var tete = document.querySelector('.site-header'), hb = tete ? Math.max(0, tete.getBoundingClientRect().bottom) : 0;
        var rr = (robot || rep).getBoundingClientRect();
        if (rr.top < hb || r.bottom > innerHeight) scrollBy({ top: rr.top - hb - 8, behavior: reduce ? 'auto' : 'smooth' });
      }
      try { rep.focus({ preventScroll: true }); } catch (e) { rep.focus(); }
    }
    function repondre(x) {
      pose('repond');
      carte('<p class="zr-r-q">' + esc(x.q) + '</p><div class="zr-r-a">' + (x.a ? x.a.innerHTML : '') + '</div>');
    }
    function retour() {
      rep.hidden = true; rep.innerHTML = '';
      scene.classList.remove('a-repondu');
      pose('attend');
      $$('.zr-wisp.parti', nuage).forEach(function (b) { b.classList.remove('parti'); });
      var b = nuage.querySelector('.zr-wisp');
      if (b) b.focus({ preventScroll: true });
    }

    /* le guide : où, (chez toi) quoi, budget, puis le produit */
    function guide(choix) {
      var etape = !choix.lieu ? 'lieu' : choix.lieu === 'maison' && !choix.besoin ? 'besoin' : choix.budget == null ? 'budget' : null;
      if (!etape) { resultat(choix); return; }
      pose('repond');
      var n = choix.lieu === 'maison' ? 3 : 2, k = etape === 'lieu' ? 1 : etape === 'besoin' ? 2 : n;
      var e = ETAPES[etape];
      carte('<p class="zr-r-q">' + esc(T('zero_guide_titre', 'Quel filtre pour moi ?')) + ' <span class="zr-pas">' + k + '/' + n + '</span></p>' +
        '<p class="zr-g-q">' + esc(e.q) + '</p><div class="zr-g-o">' +
        e.o.map(function (o) { return '<button type="button" class="zr-opt" data-v="' + o[0] + '">' + esc(o[1]) + '</button>'; }).join('') + '</div>');
      $$('.zr-opt', rep).forEach(function (b) {
        b.addEventListener('click', function () {
          var c = Object.assign({}, choix);
          c[etape] = b.getAttribute('data-v');
          guide(c);
        });
      });
    }
    function resultat(choix) {
      var l = choix.lieu === 'maison' ? GUIDE.maison[choix.besoin] : GUIDE[choix.lieu], b = +choix.budget, h = null;
      [b, b - 1, b - 2, b + 1, b + 2].forEach(function (k) { if (!h && k >= 0 && k < 3 && l && P[l[k]]) h = l[k]; });
      if (!h) { inconnue(); return; }
      var p = P[h], cle = choix.lieu === 'maison' ? 'maison_' + choix.besoin : choix.lieu;
      var note = p.c > BUDGET_MAX[b] ? ' ' + T('zero_guide_plus_abordable', 'C\'est le plus abordable pour ça.') : '';
      pose('content');
      carte('<p class="zr-r-q">' + esc(T('zero_guide_pour_toi', 'Pour toi :')) + '</p>' +
        '<a class="zr-produit" href="' + esc(p.u) + '">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '<span><b>' + esc(p.t) + '</b><span class="zr-prix">' + esc(p.p) + '</span></span></a>' +
        '<p class="zr-r-a">' + esc(RAISON[cle] || '') + esc(note) + '</p>',
        '<button class="btn btn-solid zr-ajout" type="button" data-v="' + esc(p.v) + '">' + esc(T('add_to_cart', 'Ajouter au panier')) + '</button>' +
        '<button class="zr-refaire" type="button">' + esc(T('zero_guide_refaire', 'Recommencer')) + '</button>');
      rep.querySelector('.zr-refaire').addEventListener('click', function () { guide({}); });
      var ajout = rep.querySelector('.zr-ajout');
      ajout.addEventListener('click', function () { ajouter(ajout); });
    }
    function inconnue() {
      var x = parId.inconnue;
      pose('ecoute');
      carte('<div class="zr-r-a">' + (x && x.a ? x.a.innerHTML : '') + '</div>');
    }

    /* ajout direct : cart/add.js, puis la pastille du panier suit le vrai total */
    function ajouter(btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      var id = +btn.getAttribute('data-v');
      if (!shopRoot || !id) return;
      btn.setAttribute('aria-busy', 'true');
      var json = function (r) { return r.json().then(function (d) { return r.ok ? d : Promise.reject(d); }); };
      fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(json)
        .then(function () {
          btn.removeAttribute('aria-busy');
          var a = document.createElement('a');
          a.className = 'btn btn-solid zr-ajout';
          a.href = shopRoot + 'cart';
          a.textContent = T('zero_ajoute', 'Ajouté : voir mon panier');
          btn.replaceWith(a);
          return fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (c) {
            $$('.cart-count').forEach(function (el) { el.textContent = c.item_count; });
          });
        })
        .catch(function (err) {
          btn.removeAttribute('aria-busy');
          btn.textContent = (err && err.description) || T('add_error', 'Ajout impossible pour le moment.');
        });
    }

    /* question tapée : mots-clés de la base (.zr-mots), puis la question, puis la réponse */
    function chercher(s) {
      var mots = norm(s).split(' ').filter(function (w) { return w.length >= 4; }).map(function (w) { return w.slice(0, 5); });
      var best = null, max = 0;
      QR.forEach(function (x) {
        if (x.id === 'inconnue') return;
        var q = norm(x.q), a = norm(x.a ? x.a.textContent : ''), sc = 0;
        mots.forEach(function (w) { sc += x.mots.indexOf(w) >= 0 ? 3 : q.indexOf(w) >= 0 ? 2 : a.indexOf(w) >= 0 ? 1 : 0; });
        if (sc > max) { max = sc; best = x; }
      });
      return max >= 3 ? best : null;
    }
    if (form && champ) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var s = champ.value.trim();
        if (!s || occupe) return;
        var x = chercher(s), r = champ.getBoundingClientRect();
        champ.value = '';
        occupe = true;
        scene.classList.remove('a-repondu');
        rep.hidden = true;
        pose('ecoute');
        setTimeout(function () {
          aspirer(r, s, function () {
            occupe = false;
            if (!x) inconnue(); else if (x.id === 'guide') guide({}); else repondre(x);
          });
        }, reduce ? 0 : 380);
      });
    }

    volutes();
    pose('attend');
    root.classList.add('zr-pret');
  }

  /* accueil : la scène */
  $$('section.zr[data-ctx]').forEach(function (s) { Zero(s, s.getAttribute('data-ctx')); });

  /* fiches et panier : Zéro passe la tête quand le visiteur hésite */
  $$('.zr-panneau-wrap').forEach(function (w) {
    var ctx = w.getAttribute('data-ctx') || 'autre';
    var peek = w.querySelector('.zr-peek'), panneau = w.querySelector('.zr-panneau');
    if (!peek || !panneau) return;
    try { if (sessionStorage.getItem('sz-zero-ferme') === '1') { w.remove(); return; } } catch (e) { /* stockage bloqué */ }
    var fait = false, pret = false, montre = false, minuterie = null, retrait = null;

    /* au-dessus des barres d'achat collantes et de la bannière cookies */
    function caler() {
      var bas = 16;
      $$('.mobile-buybar, .vt-buybar.on').forEach(function (b) {
        if (b.classList.contains('is-hidden')) return;
        var r = b.getBoundingClientRect();
        if (r.height && r.top < innerHeight) bas = Math.max(bas, innerHeight - r.top + 12);
      });
      var ban = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pc-banner-h')) || 0;
      w.style.setProperty('--zero-bas', Math.max(bas, ban + 16) + 'px');
    }
    function montrer() {
      if (montre || fait) return;
      montre = true;
      clearTimeout(minuterie);
      caler();
      setTimeout(caler, 900);   // bannière cookies mesurée par app.js après le chargement
      peek.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { peek.classList.add('on'); }); });
      /* sans réponse du visiteur, il se retire au bout de 14 s */
      retrait = setTimeout(function () { if (!panneau.hidden) return; peek.classList.remove('on'); setTimeout(function () { peek.hidden = true; }, 600); }, 14000);
    }
    function ouvrir() {
      clearTimeout(retrait);
      peek.classList.remove('on'); peek.hidden = true;
      if (!pret) { pret = true; Zero(panneau, ctx); }
      caler();
      panneau.hidden = false;
      requestAnimationFrame(function () { panneau.classList.add('on'); });
      var t = panneau.querySelector('.zr-fermer');
      if (t) t.focus({ preventScroll: true });
    }
    function fermer() {
      fait = true;
      panneau.classList.remove('on');
      setTimeout(function () { panneau.hidden = true; }, reduce ? 0 : 300);
      try { sessionStorage.setItem('sz-zero-ferme', '1'); } catch (e) { /* stockage bloqué */ }
    }
    peek.addEventListener('click', ouvrir);
    panneau.querySelector('.zr-fermer').addEventListener('click', fermer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panneau.hidden) fermer(); });
    addEventListener('scroll', function () { if (montre && !fait) caler(); }, { passive: true });

    /* hésitation : 25 s sur une fiche (12 s dans le panier) sans ajout, ou le bas de la page atteint */
    minuterie = setTimeout(montrer, ctx === 'panier' ? 12000 : 25000);
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) { clearTimeout(minuterie); fait = !montre; }
    }, true);
    /* le bas de page compte seulement après un vrai défilement : une page courte (panier vide) le montre d'emblée */
    var pied = document.querySelector('footer, .site-footer');
    if (pied && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (es[0].isIntersecting && scrollY > innerHeight * 0.6) montrer(); }).observe(pied);
    }
    addEventListener('resize', function () { if (montre && !fait) caler(); });
  });
})();
